import {Observable} from 'rxjs';
import {jobHunterAPI, RestQueryParams} from 'jobhunter-common-web';

export function getServicesAPI(params?: typeof RestQueryParams): Observable<any> {
    const queryParams = params ? params : new RestQueryParams(),
        headers = undefined;

    return jobHunterAPI.get('api/services', queryParams, headers);
}
